const EmployeeRow = ({ employee, days, assignments }) => {
  return (
    <div className="planner-row">
      <div className="emp-col">
      <div className="name-avr">
        <div className="avatar">
          {employee.first_name?.[0]}
        </div>
        <div className="name-des">
          <strong>{employee.first_name} {employee.last_name}</strong>
          <small>{employee.designation}</small>
        </div>
        </div>
      </div>

      {days.map(d => {
        const dateKey = d.toISOString().split("T")[0];
        const shift = assignments.find(a => a.date === dateKey);

        return (
          <div key={dateKey} className={`shift-cell ${shift ? "assigned" : ""}`}>
            {shift ? shift.shift_name : "—"}
          </div>
        );
      })}
    </div>
  );
};

export default EmployeeRow;
